import React from 'react';
import {
  AppBar,
  Tab,
  Tabs,
  Tooltip,
} from '@material-ui/core';

export default function TiersWhitelist(props) {
  const {
    memberTiers,
    memberTiersTabClasses,
    questType,
    setSubTab,
    streamingQuest = true,
    isYoutubeVideoQuest = false,
    subTab,
    viewerTiers,
    viewerTiersTabClasses,
    whitelist,
    whitelistTabClasses,
  } = props;

  if (!questType) {
    return <div className='payment-blocker'>
        <span>Select a Quest Type to access Payment Information.</span>
      </div>;
  }

  // 确保 subTab 是数字类型，默认为 0
  const currentTab = typeof subTab === 'number' ? subTab : 0;

  return (
    <div>
      <AppBar position="static" color="default">
        <Tabs
          value={currentTab}
          onChange={(e, newTab) => {
            if (typeof setSubTab === 'function') {
              setSubTab(Number(newTab));
            }
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tooltip
            title={
              streamingQuest
                ? "These are tiers that will allow people to join based on average viewers."
                : isYoutubeVideoQuest
                ? "These are tiers that will allow people to join based on average play count."
                : "This is the default payment amount for the quest."
            }
            placement="top"
            interactive
          >
            <Tab
              id="viewerTiers"
              label={
                <>
                  {(streamingQuest || isYoutubeVideoQuest) ? 'Viewer Tiers' : 'Default Payment'}
                  &nbsp;<i className={viewerTiersTabClasses} />
                </>
              }
            />
          </Tooltip>
          <Tooltip
            title={
              questType === 'youtube-video'
                ? "These are tiers that will allow users to join based on Noiz Username or YouTube Username."
                : "These are tiers that will allow users to join based on Twitch User Name."
            }
            placement="top"
            interactive
          >
            <Tab
              id="memberTiers"
              label={<>Member Tiers&nbsp;<i className={memberTiersTabClasses} /></>}
            />
          </Tooltip>
          <Tooltip
            title={
              questType === 'youtube-video'
                ? "Whitelist Noiz Usernames or YouTube Usernames for private access."
                : "Whitelist Noiz Usernames or Twitch Usernames for private access."
            }
            placement="top"
            interactive
          >
            <Tab
              id="whitelist"
              label={<>Whitelist&nbsp;<i className={whitelistTabClasses} /></>}
            />
          </Tooltip>
        </Tabs>
      </AppBar>
      {/* 使用 display 控制显示/隐藏，确保组件保持挂载 */}
      <div style={{ display: currentTab === 0 ? 'block' : 'none' }}>
        {viewerTiers && viewerTiers()}
      </div>
      <div style={{ display: currentTab === 1 ? 'block' : 'none' }}>
        {memberTiers && memberTiers()}
      </div>
      <div style={{ display: currentTab === 2 ? 'block' : 'none' }}>
        {whitelist && whitelist()}
      </div>
    </div>
  );
}
